import React, { useEffect, useState } from "react";
import InputFiled from "../../../../Components/FormTag/InputFiled";
import GetSvgIcon from "../../../../assets/images/svgList";

import {
  validateASN,
  validateMobileField,
} from "../Service/InboundServices";
import SweetAlertComponent from "../../../../Components/SweetAlertComponent";
import { Toaster, toast } from "react-hot-toast";
import { ScanningInputProps } from "../Model/Mobile.type";

const ScanPanel: React.FC<ScanningInputProps> = ({
  register,
  textValue,
  handleFieldChange,
  setTextValue,
  valueChecker,
  asnValidateResponse,
  setAsnValidateResponse,
  setValueChecker
}) => {
  
  const [textValueTypeNumeric, setextValueTypeNumeric] = useState<boolean>(false);
  const playsound = (code:any) => {
    const beepObject: { [key: string]: string } = { "200": "/beep.mp3", "409": "/waring-beep.wav" };
    const audio = new Audio(beepObject[code as keyof typeof beepObject]);
    audio.load();
    audio.play().catch((error) => {
      console.error("Audio play failed:", error);
      const audioContext = new (window.AudioContext ||
        (window as any).webkitAudioContext)();
      audioContext.resume().then(() => {
        audio
          .play()
          .catch((error) =>
            console.error("Audio play failed after resume:", error)
          );
      });
    });
  }
  const handleAlertButtonClick=()=>{
    
  }
    useEffect(() => {
      setextValueTypeNumeric(false);
      setTextValue("");
    }, [asnValidateResponse]);
  const istextValueValid=(textValue:any)=>{

    if (textValueTypeNumeric==true) {
      return !isNaN(parseFloat(textValue)) && !isNaN(Number(textValue)) && typeof textValue === 'string';
     }
     return true;
  }
  const handleItemValidate = () => {
    if(!istextValueValid(textValue)){
      setValueChecker({
        error: false,
        errorMessage: `Please enter a numeric value`,
      });
      return;
    }
    let payload= asnValidateResponse?.attributes?.call_back_url_params as any;
    let call_back_url=(asnValidateResponse?.attributes?.callback_url)?asnValidateResponse?.attributes?.callback_url:asnValidateResponse?.attributes?.call_back_url as any;
    if(asnValidateResponse?.attributes.action!="success" && asnValidateResponse?.attributes.beep_code!=200){
        payload.scan_value=textValue;
    }
    try {
      callValidateApi(call_back_url,payload);
    } catch (error: any) {
      toast.error("Something Went Wrong", { duration: 2000 });
    }
  };

  const callValidateApi=(call_back_url:any,payload:any)=>{
    validateMobileField(call_back_url, payload).then((response) => {
      let res = response as any;
      if (res?.error?.code) {
        toast.error(res.error.detail, { duration: 3000 });
        return;
      }
      if (response.data) {
        setAsnValidateResponse(response.data);
        setTextValue("");
         if(response?.data.attributes.numeric_keyboard){
          setextValueTypeNumeric(true);
         }else{
          setextValueTypeNumeric(false);
         }
         if(response.data.attributes.action=="success" && response.data.attributes.beep_code==409){ 
          playsound(409);
          triggerSweetAlert(response.data.attributes.popup_message ?? "",GetSvgIcon.ScannerWarningLogo);
           callValidateApi(response.data.attributes.call_back_url,response.data.attributes.call_back_url_params);
         }
        if(response.data.attributes.action=="success" && response.data.attributes.beep_code==200){ 
          if (response.data.attributes.call_back_url_params) {
            playsound(200);
            triggerSweetAlert(response.data.attributes.popup_message ?? "",GetSvgIcon.ScannerSuccessLogo);
            validateASN(response.data.attributes.call_back_url_params).then(
              (response) => {
                setAsnValidateResponse(response.data);
              }
            );
          }
        }
      }
    });
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      if (textValue) {
        handleItemValidate();
      }
    }
  };
  const triggerSweetAlert = (message: string,logo:any) => {
    // Call the SweetAlert service with the message
    SweetAlertComponent.showAlert({
      logo: logo,
      text: message,
      buttonText: "Done",
      onButtonClick: handleAlertButtonClick,
    });
  };
  return (
    <>
      <Toaster />
      <div className="bg-white p-4 scanning-area-bottom">
        <div className="d-flex align-items-center justify-content-around scanning-area-top">
          {asnValidateResponse?.attributes.blue_text}
        </div>

        <div className="d-flex align-items-center gap-2 mt-2">
          <div className="input-group scanner-input-group">
            <InputFiled
              type="text"
              name="scan_value"
              className=
                {`p-0 form-control rounded-start-pill border-end-0 p-3 scanner-input ${asnValidateResponse?.attributes.scan_icon ? '' : 'scanner-input-text'}`}
              placeholder={asnValidateResponse?.attributes.scan_text}
              tabIndex={4}
              value={textValue}
              register={register}
              onKeyDown={handleKeyPress}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleFieldChange("scan_value", e.target.value);
                setTextValue(e.target.value);
              }}
            />
            {asnValidateResponse?.attributes.scan_icon ? (
              <span
                className={`${
                  valueChecker.errorMessage ? "border-danger" : "border-info"
                } input-group-text rounded-end-pill bg-white border border-start-0 cursor-pointer`}
                onClick={handleItemValidate}
              >
                {GetSvgIcon.UpcScanner}
              </span>
            ) : (
              <></>
            )}
          </div>
          {asnValidateResponse?.attributes.scan_icon ? (
            <></>
             ) : (
          <span
            className="input-group-text bg-white cursor-pointer scanner-enter-icon"
            onClick={handleItemValidate}
          >
            {GetSvgIcon.ArrowReturnLeft}
          </span>
           )}
        </div>
           {
             valueChecker.errorMessage && ( <small className="ms-4 text-danger">{valueChecker.errorMessage}</small>)
           }
       
      </div>
      <div className="d-flex justify-content-between mt-2 gap-2">
        <div className="col">
          <div className="top-tab p-3 d-flex justify-content-between">
            <div>
              <strong>Expected Qty :</strong>
              {/* <strong>{asnValidateResponse?.attributes.upper_left?.title}:</strong> */}
              
            </div>
            <div className="scanner-expected-qty d-flex align-items-center">
              {asnValidateResponse?.attributes.action=="success" ?(<>{GetSvgIcon.RoundTik}</>):
              
              (<> 
              <span title={`${asnValidateResponse?.attributes.upper_left?.title} - ${asnValidateResponse?.attributes.upper_left?.value} / ${asnValidateResponse?.attributes.upper_right?.title} - ${asnValidateResponse?.attributes.upper_right?.value}`}>
              {GetSvgIcon.getProgressCircle(asnValidateResponse?.attributes.upper_left?.value??0,asnValidateResponse?.attributes.upper_right?.value??0)}
              </span>
              </>)
              }
              
              <strong className="ms-2">{asnValidateResponse?.attributes.upper_left?.value}</strong>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="top-tab p-3 d-flex justify-content-between">
            <div>
              <strong>Item/UPC :</strong>
              {/* <strong>{asnValidateResponse?.attributes.item?.title} :</strong> */}
            </div>
            <div>
              <strong>
              {asnValidateResponse?.attributes.item?.value}
              </strong>
            </div>
          </div>
        </div>

      </div>
      {/* <div className="d-flex justify-content-between mt-2 gap-2">
        {asnValidateResponse?.attributes.upper_right?.value && <div className="col">
          <div className="top-tab p-3 d-flex justify-content-between">
            <div>
              <strong> {asnValidateResponse?.attributes.upper_right?.title} :</strong>
            </div>
            <div>
              <strong>
                {asnValidateResponse?.attributes.upper_right?.value}
              </strong>
            </div>
          </div>
        </div>}
        {asnValidateResponse?.attributes.upper_right_bottom?.value && <div className="col">
          <div className="top-tab p-3 d-flex justify-content-between">
            <div>
              <strong>{asnValidateResponse?.attributes.upper_right_bottom?.title}</strong>
            </div>
            <div>
              <strong>
                {asnValidateResponse?.attributes.upper_right_bottom?.value}
              </strong>
            </div>
          </div>
        </div>
        }

      </div> */}
    </>
  );
};

export default ScanPanel;
